<template>
  <div class="markup" v-html="sanitizedMarkdown"></div>
</template>

<script>
import { computed } from 'vue';
import { marked } from 'marked';
import { useSanitize } from '~/composables/useSanitize';

export default {
  name: 'TextMessage',
  props: {
    messageText: {
      type: String,
      default: '',
    },
    isTyping: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // const renderNewLines = (text) => text.replace(/\n/g, '<br>');
    const { sanitize } = useSanitize();
    const parsedMarkdown = computed(() =>
      props.isTyping
        ? marked(props.messageText + '<span v-if="isTyping" class="cursor" />')
        : marked(props.messageText),
    );
    const sanitizedMarkdown = computed(() => sanitize(parsedMarkdown.value));

    return {
      sanitizedMarkdown,
    };
  },
};
</script>
<style scoped lang="scss">
.markup {
  word-break: break-word;
  font-size: 15px;
  line-height: $bb-spacing-5;
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-4;

  :deep(ul),
  :deep(ol) {
    padding-left: $bb-spacing-6;
    display: flex;
    flex-direction: column;
    gap: $bb-spacing-3;

    //&:not(:last-child) {
    // padding-bottom: $bb-spacing-3;
    //}
  }

  :deep(.cursor) {
    display: inline-block;
    margin-left: $bb-spacing-1;
    width: 2px;
    height: 1em;
    background-color: $bb-primary-3;
    animation: blink-animation 1s steps(20, start) infinite;
    @keyframes blink-animation {
      0%,
      100% {
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
    }
  }
}
</style>
